module.exports = __webpack_public_path__ + "img/left-arrow.f04777cc.svg";